import { assocPath, length } from 'ramda';

export default {
	UPDATE_HAS_INFORMATION(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.hasInformationJobEvaluation = payload;
	},
	UPDATE_LIST(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.userForm.jobList = payload;
	},
	UPDATE_MAIN_DATA(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.mainData = payload;
	},
	UPDATE_LEVEL_SELECTION_ROLE(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.levelSelection.role = payload;
	},
	UPDATE_LEVEL_SELECTION_TITLE(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.levelSelection.title = payload;
	},
	UPDATE_LEVEL_SELECTION_EXPERIENCE(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.levelSelection.experience = payload;
	},
	UPDATE_COMMAND_DATA(state, { command, data }) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.verbsSelection[command] = data;
	},
	UPDATE_HIERARCHY_ASSIGNATION(state, payload) {
		if (length(payload) > 0) {
			// eslint-disable-next-line no-param-reassign
			state.supplies.guidelineModel.hasPreviewValues = true;
		}
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.hierarchyAssignation = payload;
	},
	UPDATE_ORGANIZATION_CHART(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.organizationChart = payload;
	},
	UPDATE_JOB_POSITION_ASSIGNATION(state, { assignationIndex, jobPositionIndex, jobPosition }) {
		const hierarchyAssignation = state.supplies.guidelineModel.hierarchyAssignation;
		// eslint-disable-next-line no-param-reassign
		state.supplies.guidelineModel.hierarchyAssignation = assocPath(
			[assignationIndex, 'jobPositions', jobPositionIndex], jobPosition, hierarchyAssignation,
		);
	},
};



// WEBPACK FOOTER //
// ./src/modules/job-evaluation/store/guideline-model/mutations.js